var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22.5232C11.9313 22.5232 6.75 23.4934 6.75 27.3698C6.75 31.2447 11.8998 32.2499 18 32.2499C24.0672 32.2499 29.25 31.2797 29.25 27.4033C29.25 23.5269 24.1002 22.5232 18 22.5232Z",
    fill: "url(#paint0_linear_1709_14319)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.8313C22.1318 18.8313 25.4439 15.4765 25.4439 11.2914C25.4439 7.1063 22.1318 3.75 18 3.75C13.8681 3.75 10.556 7.1063 10.556 11.2914C10.556 15.4765 13.8681 18.8313 18 18.8313Z",
    fill: "#2666FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1709_14319",
    x1: 18,
    y1: 22.5232,
    x2: 18,
    y2: 32.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002C90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.86ea22ab6ec87a1b178aa97416f61bfd.svg";
export { ForwardRef as ReactComponent };